import React, { useEffect, useState } from "react";
import { useLang, UI } from "@/i18n";
import { readConsent, writeConsent } from "@/ga4";

export default function CookieBanner() {
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  const [analytics, setAnalytics] = useState(true);

  useEffect(() => {
    const consent = readConsent();
    if (!consent) {
      const timer = setTimeout(() => setOpen(true), 1600);
      return () => clearTimeout(timer);
    }
    const reopen = () => {
      setAnalytics(readConsent().analytics);
      setOpen(true);
    };
    window.addEventListener("obsidian-manage-cookies", reopen);
    return () => window.removeEventListener("obsidian-manage-cookies", reopen);
  }, []);

  if (!open) return null;

  const decide = (value) => {
    writeConsent({ necessary: true, analytics: value });
    setOpen(false);
  };

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[70] border-t hairline bg-[#0A0A0C]/95 backdrop-blur-md"
      data-testid="cookie-banner"
      role="dialog"
      aria-label="Cookie consent"
    >
      <div className="mx-auto max-w-7xl px-6 py-6 sm:px-10 lg:px-16">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-2xl">
            <p className="eyebrow mb-2">{t(UI.cookie.title)}</p>
            <p className="text-xs leading-relaxed text-[#A1A1AA] sm:text-[13px]">{t(UI.cookie.text)}</p>
            <label className="mt-4 flex cursor-pointer items-center gap-3 text-[13px] text-[#FAF9F6]/80">
              <input
                type="checkbox"
                checked={analytics}
                onChange={(e) => setAnalytics(e.target.checked)}
                className="h-4 w-4 appearance-none border border-white/30 bg-transparent checked:bg-[#C5A059] checked:border-[#C5A059] transition-colors"
                data-testid="cookie-analytics-checkbox"
              />
              {t(UI.cookie.analytics)}
            </label>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row lg:flex-col xl:flex-row">
            <button
              type="button"
              className="btn-gold justify-center !px-6 !py-3"
              onClick={() => decide(true)}
              data-testid="cookie-accept-all"
            >
              {t(UI.cookie.acceptAll)}
            </button>
            <button
              type="button"
              className="btn-outline justify-center !px-6 !py-3"
              onClick={() => decide(analytics)}
              data-testid="cookie-save-prefs"
            >
              {t(UI.cookie.save)}
            </button>
            <button
              type="button"
              className="justify-center px-6 py-3 text-[11px] uppercase tracking-[0.28em] text-[#A1A1AA] transition-colors hover:text-[#FAF9F6]"
              onClick={() => decide(false)}
              data-testid="cookie-necessary-only"
            >
              {t(UI.cookie.necessary)}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
